<template>
  <div
    class="alertio"
    :class="[
      {
        'transparent': transparent,
        'no-bg': noBackground,
        'full-size': fullSize,
        'align-center': alignCenter
      },
      type
    ]"
  >
    <div class="alertio__description">
      <SvgIcon
        v-if="c_icon"
        :name="c_icon"
        class="alertio__icon"
      />
      <UiText
        class="alertio__text"
        :font="noBackground ? 'body-caption' : 'body-text-small'"
      >
        <slot>
          {{ text }}
        </slot>
      </UiText>
    </div>
    <div v-if="isButton || isClose" class="alertio__buttons">
      <UiBtn
        v-if="isButton"
        :color="c_btnColor"
        :text="buttonText"
        size="xs"
        @click="$emit('button')"
      />
      <SvgIcon
        v-if="isClose"
        name="common/close"
        class="alertio__icon"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
const COLORS = {
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
  GRAY: 'gray',
}

export const colorValidator = (value) => Object.values(COLORS).includes(value)

export default {
  name: 'UiAlert',
  props: {
    type: { type: String, validator: colorValidator, default: COLORS.GRAY },
    transparent: { type: Boolean },
    noBackground: { type: Boolean },
    isClose: { type: Boolean },
    isButton: { type: Boolean },
    text: { type: String },
    buttonText: { type: String },
    icon: { type: String },
    fullSize: { type: Boolean },
    alignCenter: { type: Boolean },
  },
  data() {
    return {
      COLORS,
    }
  },
  computed: {
    c_icon() {
      const icons = {
        typeWarning: 'alertio/danger',
        typeError: 'alertio/close-circle',
        typeInfo: 'alertio/info-circle',
        typeSuccess: 'alertio/check-circle',
        typeGray: 'alertio/info-circle',
      }

      if (this.icon) return this.icon

      if (this.type === COLORS.WARNING) {
        return icons.typeWarning
      }
      else if (this.type === COLORS.ERROR) {
        return icons.typeError
      }
      else if (this.type === COLORS.INFO) {
        return icons.typeInfo
      }
      else if (this.type === COLORS.SUCCESS) {
        return icons.typeSuccess
      }
      else if (this.type === COLORS.GRAY) {
        return icons.typeGray
      }
      return ''
    },
    c_btnColor() {
      if (!this.transparent && !this.noBackground) return 'white'
      if (this.type === COLORS.WARNING && (this.transparent || this.noBackground)) return 'warning'
      if (this.type === COLORS.ERROR && (this.transparent || this.noBackground)) return 'error'
      if (this.type === COLORS.INFO && (this.transparent || this.noBackground)) return 'info'
      if (this.type === COLORS.SUCCESS && (this.transparent || this.noBackground)) return 'secondary'
      if (this.type === COLORS.GRAY && (this.transparent || this.noBackground)) return 'gray'

      return 'default'
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
